import { Select as SelectLib, SelectProps as SelectPropsAntd } from 'antd';
import styled from 'styled-components';

import { OptionsProps } from './Select.interface';

export const SelectContainer = styled(SelectLib)<SelectPropsAntd<OptionsProps>>`
  width: 100%;
`;
